/* v95.5 (16 Oct): keyed green-screen loops for inline slots. WebGL keyer, plays only while on screen.
   <span class="pw-loop" data-src="GREEN.mp4" [data-fit="crop"|"sit"]><canvas></canvas></span>
   fit=crop: canvas is cropped to the character (first-frame bounding box), so it drops in where a tight PNG cutout was.
   fit=sit:  canvas keeps the full frame but slides down so the feet touch the bottom edge.
   Also swaps the picks section's static Cash and Rusty cutouts for expression loops. Cash is cut at the chest so he
   peeks over the card edge (data-keep), and Rusty at the mic stands in front of the product cards.
   On an unpublished (preview) theme the phone once-per-session cap on the corner pop-ups is reset each load.
   v97.0: the hero rating line now sits under the tagline (.ns-hero__tag) when there is one, so the tagline stays directly under the H1. */
(function () {
  'use strict';
  /* the hero rating line (pw-949.js heroTrust) was navy on navy, so only its star showed: make the text cream */
  var css = '.ns-pk--cash .pw-dogv{margin-bottom:0 !important}.pw955-mic{z-index:6 !important}.ns-hero .pw949-trust,.ns-hero .pw949-trust b,.ns-hero .pw949-trust span:not(.pw949-trust__s){color:#FBF8F3 !important}'
    /* phones: lighter hero. The second headline line goes, the rating sits right under the headline */
    + '.ns-hero .pw955-trust{display:block;margin:10px 0 4px;font-size:15px;line-height:1.4;text-decoration:none}'
    + '@media (max-width:749px){.ns-hero .ns-hero__h2{display:none !important}.ns-hero .pw955-trust{margin:8px 0 2px}}';
  var PREVIEW = false;
  try { PREVIEW = /preview_theme_id/.test(location.search) || !!(window.Shopify && (Shopify.designMode || (Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main'))); } catch (e) {}
  try { if (PREVIEW) {
    sessionStorage.removeItem('pw-m-shown'); sessionStorage.removeItem('pw-peek-off');
    /* the Shopify preview bar covers the bottom corners on phones: lift the pop-ups above it in previews only */
    css += '@media (max-width:749px){.pw-peek{bottom:118px !important}}';
  } } catch (e) {}
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);
  heroTrust();
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var F = 'https://cdn.shopify.com/s/files/1/0888/1628/8064/files/';
  var DOGS = { cash: F + 'pwgx-cash-nod.mp4', rusty: F + 'pwgx-rusty-wiggle.mp4' };
  var VS = 'attribute vec2 p;varying vec2 u;uniform vec4 r;void main(){vec2 q=vec2(p.x*.5+.5,.5-p.y*.5);u=r.xy+q*r.zw;gl_Position=vec4(p,0.,1.);}';
  var FS = 'precision mediump float;varying vec2 u;uniform sampler2D t;void main(){vec4 c=texture2D(t,u);float m=max(c.r,c.b);float k=c.g-m;float a=1.-smoothstep(.10,.28,k);vec3 col=c.rgb;col.g=min(col.g,m+.04);gl_FragColor=vec4(col*a,a);}';
  function gl(cv) {
    var g = null;
    try { g = cv.getContext('webgl', { premultipliedAlpha: true, alpha: true }); } catch (e) {}
    if (!g) return null;
    function sh(t, s) { var o = g.createShader(t); g.shaderSource(o, s); g.compileShader(o); return o; }
    var pr = g.createProgram(); g.attachShader(pr, sh(g.VERTEX_SHADER, VS)); g.attachShader(pr, sh(g.FRAGMENT_SHADER, FS)); g.linkProgram(pr); g.useProgram(pr);
    var b = g.createBuffer(); g.bindBuffer(g.ARRAY_BUFFER, b); g.bufferData(g.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), g.STATIC_DRAW);
    var l = g.getAttribLocation(pr, 'p'); g.enableVertexAttribArray(l); g.vertexAttribPointer(l, 2, g.FLOAT, false, 0, 0);
    var tx = g.createTexture(); g.bindTexture(g.TEXTURE_2D, tx);
    g.texParameteri(g.TEXTURE_2D, g.TEXTURE_WRAP_S, g.CLAMP_TO_EDGE); g.texParameteri(g.TEXTURE_2D, g.TEXTURE_WRAP_T, g.CLAMP_TO_EDGE);
    g.texParameteri(g.TEXTURE_2D, g.TEXTURE_MIN_FILTER, g.LINEAR); g.texParameteri(g.TEXTURE_2D, g.TEXTURE_MAG_FILTER, g.LINEAR);
    g.__r = g.getUniformLocation(pr, 'r'); g.uniform4f(g.__r, 0, 0, 1, 1);
    return g;
  }
  /* bounding box of the character on a frame, as fractions [x, y, w, h] */
  function bbox(v) {
    try {
      var W = 72, H = 96, c = document.createElement('canvas'); c.width = W; c.height = H;
      var x = c.getContext('2d'); x.drawImage(v, 0, 0, W, H);
      var a = x.getImageData(0, 0, W, H).data, x0 = W, y0 = H, x1 = -1, y1 = -1;
      for (var y = 0; y < H; y++) for (var i = 0; i < W; i++) { var o = (y * W + i) * 4; if (a[o + 1] - Math.max(a[o], a[o + 2]) < 40) { if (i < x0) x0 = i; if (i > x1) x1 = i; if (y < y0) y0 = y; if (y > y1) y1 = y; } }
      if (x1 < 0) return null;
      var pad = 3; x0 = Math.max(0, x0 - pad); y0 = Math.max(0, y0 - pad); x1 = Math.min(W - 1, x1 + pad); y1 = Math.min(H - 1, y1 + 1);
      return [x0 / W, y0 / H, (x1 - x0 + 1) / W, (y1 - y0 + 1) / H];
    } catch (e) { return null; }
  }
  function init(el) {
    if (el.__pw) return; el.__pw = 1;
    var cv = el.querySelector('canvas') || el, g = gl(cv);
    if (!g) return;
    var fit = el.getAttribute('data-fit') || '';
    var v = document.createElement('video');
    v.muted = true; v.loop = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.setAttribute('muted', ''); v.crossOrigin = 'anonymous'; v.preload = 'auto';
    var raf = 0, on = false, framed = !fit;
    function frame() {
      var b = bbox(v); framed = true;
      if (!b) return;
      if (fit === 'crop') {
        var keep = +(el.getAttribute('data-keep') || 1); b[3] *= keep;
        g.uniform4f(g.__r, b[0], b[1], b[2], b[3]);
        var w = 360; cv.width = w; cv.height = Math.round(w * (b[3] * 4) / (b[2] * 3));
      } else if (fit === 'sit') {
        cv.style.transform = 'translateY(' + ((1 - b[1] - b[3]) * 100).toFixed(1) + '%)';
      }
    }
    function draw() {
      if (!on) return;
      if (v.readyState >= 2) {
        if (!framed) frame();
        g.viewport(0, 0, cv.width, cv.height); g.clearColor(0, 0, 0, 0); g.clear(g.COLOR_BUFFER_BIT);
        try { g.texImage2D(g.TEXTURE_2D, 0, g.RGBA, g.RGBA, g.UNSIGNED_BYTE, v); g.drawArrays(g.TRIANGLE_STRIP, 0, 4); el.classList.add('is-live'); } catch (e) { stop(); return; }
      }
      raf = requestAnimationFrame(draw);
    }
    function start() { if (on) return; on = true; if (!v.src) v.src = el.getAttribute('data-src'); var p = v.play(); if (p && p.catch) p.catch(function () {}); draw(); }
    function stop() { on = false; cancelAnimationFrame(raf); v.pause(); }
    new IntersectionObserver(function (es) { es.forEach(function (e) { e.isIntersecting && !document.hidden ? start() : stop(); }); }, { rootMargin: '160px' }).observe(el);
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); });
  }
  /* picks section: replace each static cutout with a cropped loop that inherits the cutout's placement */
  function dogs() {
    ['cash', 'rusty'].forEach(function (k) {
      var img = document.querySelector('.ns-pk--' + k + ' img.ns-pk__dog');
      if (!img || img.__pw) return; img.__pw = 1;
      var c = document.createElement('canvas');
      c.width = 360; c.height = 480;
      c.className = img.className + ' pw-loop pw-dogv';
      c.setAttribute('data-src', DOGS[k]); c.setAttribute('data-fit', 'crop'); if (k === 'cash') c.setAttribute('data-keep', '.68'); c.setAttribute('aria-hidden', 'true');
      img.parentNode.insertBefore(c, img.nextSibling);
      new MutationObserver(function () { if (c.classList.contains('is-live')) img.style.visibility = 'hidden'; }).observe(c, { attributes: true, attributeFilter: ['class'] });
    });
  }
  /* hero: move the rating line (built by pw-949.js) up under the headline (under the tagline when there is one). Free shipping already sits in the top bar. */
  function heroTrust() {
    var h = document.querySelector('.ns-hero .ns-hero__h');
    if (!h) return;
    function move() {
      var t = document.querySelector('.ns-hero .pw949-trust');
      if (!t || t.classList.contains('pw955-trust')) return !!t;
      t.classList.add('pw955-trust');
      var tg = document.querySelector('.ns-hero .ns-hero__tag');
      h.parentNode.insertBefore(t, (tg || h).nextSibling);
      return true;
    }
    if (move()) return;
    var mo = new MutationObserver(function () { if (move()) mo.disconnect(); });
    mo.observe(document.querySelector('.ns-hero') || document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 8000);
  }
  function scan() { dogs(); document.querySelectorAll('.pw-loop[data-src]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
})();